import { render, staticRenderFns } from "./ScheduleCalendarMessage.vue?vue&type=template&id=45839998&scoped=true&"
import script from "./ScheduleCalendarMessage.vue?vue&type=script&lang=js&"
export * from "./ScheduleCalendarMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45839998",
  null
  
)

export default component.exports